import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aisuitable-for',
  templateUrl: './aisuitable-for.component.html',
  styleUrls: ['./aisuitable-for.component.scss']
})
export class AISuitableForComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
